module.exports = __webpack_public_path__ + "img/vipevent_monomer_icon@2x.f0987877.png";